<template>
  <div>
    <ErrorModal
      v-if="error.show"
      :data="error.data"
      :load-times="error.loadTimes"
      :reset-session="error.resetSession"
      :hide-buttons="error.hidebuttons"
    />
    <ConcardisModal
      v-if="showConcardis"
      v-model="paymentData"
      @retry="submit()"
      @cancel="cancel()"
      @pay="pay()"
    />
    <reservationheader :step="4" />
    <reservationinfobar step="4" />
    <div class="orm-reservationRatesExtras orm-background--grey orm-py-16">
      <div class="orm-container">
        <div class="orm-row">
          <div class="orm-col-xs-12 orm-col-md-6 orm-mb-16">
            <div
              class="orm-background--white orm-reservation__data__container__inner orm-h100"
              v-if="carID"
            >
              <div class="orm-row orm-h100">
                <div class="orm-col-xs-12">
                  <h2 class="orm-headline__h1">
                    {{ i18n("step4/reservationdata") }}
                  </h2>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-sm-6 orm-mb-16"
                  v-if="
                    store.getters['stations/GET_STATION_BY_ID'](
                      this.stationSelected
                    ).branch !== 'Auto-Abo'
                  "
                >
                  <div
                    class="orm-borderRadius__small orm-reservationFinal__datebox orm-py-16 orm-px-16"
                  >
                    <div class="orm-mb-16">
                      <strong>{{ i18n("general/pickup") }}</strong>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fas fa-map-marker-alt"></i
                      ></span>
                      <div>
                        <div>
                          <strong> {{ startstation.name }}</strong>
                        </div>
                        <small>
                          {{ startstation.street }}, {{ startstation.zipcode }}
                          {{ startstation.city }}</small
                        >
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fal fa-calendar-alt"></i
                      ></span>
                      <div>
                        <strong> {{ formateDateShort(date.start) }}</strong>
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex">
                      <span class="orm-pr-16"
                        ><i class="fal fa-clock"></i
                      ></span>
                      <div>
                        <strong>
                          {{ time.start }} {{ i18n("general/hour") }}</strong
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="orm-col-xs-12 orm-col-sm-6 orm-mb-16" v-else>
                  <div
                    class="orm-borderRadius__small orm-reservationFinal__datebox orm-py-16 orm-px-16"
                  >
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fas fa-map-marker-alt"></i
                      ></span>
                      <div>
                        <div>
                          <strong> {{ startstation.name }}</strong>
                        </div>
                        <small>
                          {{ startstation.street }}, {{ startstation.zipcode }}
                          {{ startstation.city }}</small
                        >
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fal fa-calendar-alt"></i
                      ></span>
                      <div>
                        <strong> {{ formateDateDayLong(date.start) }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-sm-6 orm-mb-16"
                  v-if="
                    store.getters['stations/GET_STATION_BY_ID'](
                      this.stationSelected
                    ).branch !== 'Auto-Abo'
                  "
                >
                  <div
                    class="orm-borderRadius__small orm-reservationFinal__datebox orm-py-16 orm-px-16"
                  >
                    <div class="orm-mb-16">
                      <strong>{{ i18n("general/delivery") }}</strong>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fas fa-map-marker-alt"></i
                      ></span>
                      <div>
                        <div>
                          <strong> {{ endstation.name }}</strong>
                        </div>
                        <small>
                          {{ endstation.street }}, {{ endstation.zipcode }}
                          {{ endstation.city }}</small
                        >
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fal fa-calendar-alt"></i
                      ></span>
                      <div>
                        <strong> {{ formateDateShort(date.end) }}</strong>
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex">
                      <span class="orm-pr-16"
                        ><i class="fal fa-clock"></i
                      ></span>
                      <div>
                        <strong>
                          {{ time.end }} {{ i18n("general/hour") }}</strong
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="orm-col-xs-12 orm-col-sm-6 orm-mb-16" v-else>
                  <div
                    class="orm-borderRadius__small orm-reservationFinal__datebox orm-py-16 orm-px-16"
                  >
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fas fa-map-marker-alt"></i
                      ></span>
                      <div>
                        <div>
                          <strong> {{ endstation.name }}</strong>
                        </div>
                        <small>
                          {{ endstation.street }}, {{ endstation.zipcode }}
                          {{ endstation.city }}</small
                        >
                      </div>
                    </div>
                    <div class="orm-reservationFinal__flex orm-mb-8">
                      <span class="orm-pr-16"
                        ><i class="fal fa-calendar-alt"></i
                      ></span>
                      <div>
                        <strong> {{ formateDateDayLong(date.end) }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="orm-col-xs-12 orm-col-sm-7 bottom-self-xs"></div>
                <div
                  class="orm-col-xs-12 orm-col-sm-5 text-right bottom-self-xs"
                >
                  <button
                    @click="edit('1')"
                    class="orm-button__cta outline small"
                  >
                    {{ i18n("general/edit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="orm-col-xs-12 orm-col-md-6 orm-pl-8 orm-mb-16">
            <div
              class="orm-background--white orm-reservation__data__container__inner orm-h100"
              v-if="carID && !selectedVehicleInfo"
            >
              <div class="orm-row orm-h100">
                <div class="orm-col-xs-12">
                  <h2 class="orm-headline__h1">{{ i18n("step4/vehicle") }}</h2>
                </div>
                <div class="orm-col-xs-12 orm-col-sm-7">
                  <div class="" v-if="images">
                    <Slider v-if="images" :images="images" />
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-sm-5 orm-border__left orm-pl-sm-16"
                  style="align-self: center"
                >
                  <div class="orm-carequip">
                    <p
                      class="orm-equip__txt__icons"
                      v-if="selectedCargroupInfo"
                    >
                      <equipIcon
                        :key="selectedCargroupInfo"
                        :data="selectedCargroupInfo.features"
                        :shortlist="false"
                      />
                    </p>
                    <p
                      class="orm-equip__txt__freemiles"
                      v-if="price.length > 0"
                    >
                      <span v-if="price && !price[0].all_km_inclusive"
                        >{{ i18n("step4/inclusive") }} {{ price[0].km_free }}
                        {{ i18n("step4/freeKilometers") }}</span
                      >
                      <span v-else
                        >{{ i18n("step4/inclusive") }}
                        {{ i18n("step4/unlimited") }}
                        {{ i18n("step4/freeKilometers") }}</span
                      >
                    </p>
                  </div>
                </div>

                <div class="orm-col-xs-12 orm-col-sm-7 bottom-self-xs">
                  <div
                    v-if="selectedCargroupInfo"
                    class="orm-cargroup__container"
                  >
                    <h3 class="orm-headline__h2">
                      <div>
                        {{
                          stripHTML(
                            selectedCargroupInfo[
                              env.VUE_APP_RESERVATION_CARGROUP
                            ]
                          )
                        }}
                      </div>
                    </h3>
                    <p
                      class="orm-headline__h3__subheadline orm-mb-0 orm-relative"
                    >
                      {{
                        stripHTML(
                          selectedCargroupInfo[
                            env.VUE_APP_RESERVATION_CARCATEGORY
                          ]
                        )
                      }}
                      <i class="fal fa-question-circle orm-cargroup__tooltip"
                        ><span
                          class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
                          >{{ i18n("cargroup/noguarantee") }}</span
                        ></i
                      >
                    </p>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-sm-5 text-right bottom-self-xs"
                >
                  <button
                    @click="edit('1')"
                    class="orm-button__cta outline small"
                  >
                    {{ i18n("general/edit") }}
                  </button>
                </div>
              </div>
            </div>
            <div
              class="orm-background--white orm-reservation__data__container__inner orm-h100"
              v-if="carID && selectedVehicleInfo"
            >
              <div class="orm-row orm-h100">
                <div class="orm-col-xs-12">
                  <h2 class="orm-headline__h1">{{ i18n("step4/vehicle") }}</h2>
                </div>
                <div class="orm-col-xs-12 orm-col-sm-7">
                  <div class="" v-if="images">
                    <Slider v-if="images" :images="images" />
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-sm-5 orm-pl-sm-16"
                  style="align-self: center"
                >
                  <h2 class="orm-headline__h2">
                    {{ stripHTML(selectedVehicleInfo.vehicle_name) }}
                  </h2>
                  <h3
                    class="orm-headline__h3__subheadline orm-mb-0 orm-relative"
                  >
                    {{ stripHTML(selectedVehicleInfo.vehicle_group.text_web) }}
                    <span v-if="selectedVehicleInfo.fuel_type">
                      - {{ selectedVehicleInfo.fuel_type }}
                    </span>
                    <span
                      v-if="
                        selectedVehicleInfo.features.find(
                          (item) => item.id === 'AT'
                        )
                      "
                    >
                      -
                      {{
                        selectedVehicleInfo.features.find(
                          (item) => item.id === "AT"
                        ).description
                      }}
                    </span>
                  </h3>
                </div>

                <div class="orm-col-xs-12 orm-col-sm-7 bottom-self-xs"></div>
                <div
                  class="orm-col-xs-12 orm-col-sm-5 text-right bottom-self-xs"
                >
                  <button
                    @click="edit('1')"
                    class="orm-button__cta outline small"
                  >
                    {{ i18n("general/edit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TARIFE -->

        <div class="orm-row">
          <div class="orm-col-xs-12 orm-mb-16">
            <div
              class="orm-background--white orm-reservation__data__container__inner orm-h100"
              v-if="carID"
            >
              <div class="orm-row">
                <div class="orm-col-xs-12 orm-col-md-7 orm-list__element">
                  <h2
                    class="orm-headline__h1"
                    v-html="i18n('step4/tarifs')"
                  ></h2>
                  <div v-if="selectedCargroup">
                    <h3 class="orm-headline__h3 orm-mb-8">
                      {{ i18n("step4/tarif") }}
                    </h3>

                    <div
                      class="orm-list__bold orm-my-8"
                      v-for="tarif in selectedCargroup.main_rates"
                      :key="tarif"
                    >
                      <div class="orm-row">
                        <div class="orm-col-xs-8">
                          <span v-if="tarif.rate == 'KM'">
                            {{ tarif.amount }}&nbsp;{{ tarif.description }}
                            <span class="orm-small"
                              >({{
                                convertCurrency(
                                  showNettoPrice
                                    ? tarif.single_price
                                    : tarif.long_price
                                )
                              }}/{{ i18n("step2/kmRate") || "KM" }})</span
                            >
                            <div
                              class="orm-small"
                              v-if="tarif.description2"
                              v-html="tarif.description2"
                            ></div>
                          </span>
                          <span v-else
                            ><span v-if="tarif.amount >= 1"
                              >{{ tarif.amount }}x </span
                            >{{ tarif.description }}
                            <span class="orm-small"
                              >({{
                                convertCurrency(
                                  showNettoPrice
                                    ? tarif.single_price
                                    : tarif.long_price
                                )
                              }}/{{ tarif.unit }})</span
                            >
                          </span>
                          <div
                            class="orm-small"
                            v-if="tarif.description2"
                            v-html="tarif.description2"
                          ></div>
                        </div>
                        <div class="orm-col-xs-4 orm-price__right">
                          {{
                            convertCurrency(
                              showNettoPrice
                                ? tarif.total_price
                                : tarif.total_long_price
                            )
                          }}
                        </div>
                      </div>
                      <div v-if="tarif.position == 1" class="orm-row orm-my-8">
                        <div class="orm-col-xs-8">
                          <span v-if="!tarif.all_km_inclusive"
                            >{{ tarif.km_free }}
                            {{ i18n("step4/freeKilometers") }}
                          </span>
                          <span v-else>
                            {{ i18n("step4/unlimited") }}
                            {{ i18n("step4/freeKilometers") }}
                          </span>
                        </div>
                        <div class="orm-col-xs-4 orm-price__right">
                          {{ i18n("step4/inclusive_long") }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="orm-list__bold orm-my-8"
                      v-for="tarif in selectedCargroup.payment_rates"
                      :key="tarif"
                    >
                      <div
                        class="orm-row"
                        v-if="tarif.rate != env.VUE_APP_PAYMENT_ONLINE"
                      >
                        <div class="orm-col-xs-8">
                          <span
                            ><span v-if="tarif.amount >= 1"></span
                            >{{ tarif.description }}
                            <span class="orm-small"
                              >({{
                                convertCurrency(
                                  showNettoPrice
                                    ? tarif.single_price
                                    : tarif.long_price
                                )
                              }})</span
                            >
                          </span>
                        </div>
                        <div class="orm-col-xs-4 orm-price__right">
                          {{
                            convertCurrency(
                              showNettoPrice
                                ? tarif.total_price
                                : tarif.total_long_price
                            )
                          }}
                        </div>
                      </div>
                      <!-- <div v-if="tarif.position == 1" class="orm-row orm-my-8">
                        <div class="orm-col-xs-8">
                          <span v-if="!tarif.all_km_inclusive"
                            >{{ tarif.km_free }}
                            {{ i18n("step4/freeKilometers") }}
                          </span>
                          <span v-else>
                            {{ i18n("step4/unlimited") }}
                            {{ i18n("step4/freeKilometers") }}
                          </span>
                        </div>
                        <div class="orm-col-xs-4 orm-price__right">
                          {{ i18n("step4/inclusive_long") }}
                        </div>
                      </div> -->
                    </div>

                    <div v-if="insurances.length > 0">
                      <h3 class="orm-headline__h3 orm-mt-32 orm-mb-8">
                        {{ i18n("step4/insurances") }}
                      </h3>
                      <div
                        v-for="insurance in insurances"
                        :key="insurance"
                        class="orm-list__bold orm-my-8"
                      >
                        <div class="orm-row">
                          <div class="orm-col-xs-8">
                            {{
                              insurance.contribution >= 0 &&
                              insurance.contribution != null
                                ? insurance.description +
                                  " (" +
                                  contribution +
                                  convertCurrency(insurance.contribution) +
                                  ")"
                                : insurance.description
                            }}
                            <br />
                            <span class="orm-small"
                              >{{ insurance.description2 }} ({{
                                convertCurrency(
                                  showNettoPrice
                                    ? insurance.single_price
                                    : insurance.long_price
                                )
                              }}/{{ insurance.unit }})</span
                            >
                          </div>
                          <div class="orm-col-xs-4 orm-price__right">
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? insurance.total_price
                                  : insurance.total_long_price
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="subrates.length > 0">
                      <h3 class="orm-headline__h3 orm-mt-32 orm-mb-8">
                        {{ i18n("step4/extras") }}
                      </h3>
                      <div
                        v-for="subrate in subrates"
                        :key="subrate"
                        class="orm-list__bold orm-my-8"
                      >
                        <div class="orm-row">
                          <div class="orm-col-xs-8">
                            <span v-if="subrate.amount >= 1"
                              >{{ subrate.amount }}x
                            </span>
                            {{ subrate.description }}
                            <span class="orm-small" v-if="subrate.unit !== 'X'"
                              >{{ subrate.description2 }} ({{
                                convertCurrency(subrate.long_price)
                              }}/{{ subrate.unit }})</span
                            >
                          </div>
                          <div class="orm-col-xs-4 orm-price__right">
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? subrate.total_price
                                  : subrate.total_long_price
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="deliveryrates.length > 0">
                      <h3 class="orm-headline__h3 orm-mt-32 orm-mb-8">
                        {{ i18n("step2/deliverypickup/title") }}
                      </h3>
                      <div
                        class="orm-list__bold orm-my-8"
                        v-for="rates in deliveryrates"
                        :key="rates"
                      >
                        <div class="orm-row">
                          <div class="orm-col-xs-8">
                            {{ rates.description }}: {{ rates.amount }}
                            {{ rates.unit }}
                          </div>
                          <div class="orm-col-xs-4 orm-price__right">
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? rates.total_price
                                  : rates.total_long_price
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h3
                        class="orm-headline__h3 orm-mt-32 orm-mb-8"
                        v-if="voucherrates.length > 0"
                      >
                        {{ i18n("step4/voucher") }}
                      </h3>
                      <div class="orm-list__bold orm-my-8">
                        <div
                          v-for="voucher in voucherrates"
                          :key="voucher.id"
                          class="orm-row"
                        >
                          <div class="orm-col-xs-8">
                            {{ voucher.description }}<br /><span
                              class="orm-small"
                              v-if="!showNettoPrice"
                              >{{ voucher.description2 }}</span
                            >
                          </div>
                          <div class="orm-col-xs-4 orm-price__right">
                            {{
                              convertCurrency(
                                showNettoPrice
                                  ? voucher.single_price
                                  : voucher.total_long_price
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-md-5 text-right bottom-self-xs"
                >
                  <div v-if="endpositions.length > 0">
                    <div v-if="showNettoPrice">
                      <span
                        v-if="endpositions[0].rate == 'NS.'"
                        class="description"
                      >
                        {{ i18n("general/total") }}:
                      </span>
                      <span v-if="position.rate == 'ES.'" class="orm-pricetag">
                        <em>{{
                          convertCurrency(
                            selectedCargroup.end_positions[0].total_price
                          )
                        }}</em>
                      </span>
                    </div>
                    <div
                      v-for="(position, index) in endpositions"
                      :key="index"
                      class="orm-price-item flex-container"
                    >
                      <span
                        v-if="position.rate == 'MWST' && position.rate != 'ES.'"
                        class="description"
                      >
                        {{ i18n("general/vat") || position.description }} ({{
                          convertCurrency(position.single_price)
                        }}):
                      </span>
                      <span
                        v-if="position.rate != 'MWST' && position.rate != 'ES.'"
                        class="description"
                      >
                        {{ i18n("general/netamount") || position.description }}:
                      </span>
                      <span
                        v-if="position.rate != 'ES.'"
                        class="orm-price_item_right"
                      >
                        {{ convertCurrency(position.total_price) }}
                      </span>
                      <span v-if="position.rate == 'ES.'" class="description">
                        <em>{{ i18n("general/total") }}:</em>
                      </span>
                      <span v-if="position.rate == 'ES.'" class="orm-pricetag">
                        <em>{{ convertCurrency(position.total_price) }}</em>
                      </span>
                    </div>
                    <!--<p class="orm-pricetag">
                      {{
                        store.getters["stations/GET_STATION_BY_ID"](
                          this.stationSelected
                        ).branch !== "Auto-Abo"
                          ? i18n("general/total")
                          : i18n("general/monthly") || "Monatlich"
                      }}:
                      <em>{{
                        convertCurrency(
                          showNettoPrice
                            ? endpositions[0].total_price
                            : endpositions[2].total_price
                        )
                      }}</em>
                    </p>
                    <p class="orm-smallprint" v-if="showSaleTax">
                      {{ endpositions[1].description }}
                    </p>
                    <p class="orm-smallprint orm-mb-0" v-else>&nbsp;</p>-->
                    <p class="orm-smallprint"></p>
                  </div>
                  <button
                    @click="edit('2')"
                    class="orm-button__cta outline small"
                  >
                    {{ i18n("general/edit") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Delivery -->
        <div
          class="orm-reservation__data__container__inner orm-my-16"
          v-if="
            carID &&
              hasDeliveryPickup &&
              (deliveryPickup.deliveryStreet || deliveryPickup.pickupStreet)
          "
        >
          <div class="orm-row orm-relative">
            <div class="orm-col-xs-12">
              <h2
                class="orm-headline__h1"
                v-html="i18n('step2/deliverypickup/title')"
              ></h2>
              <div class="orm-row">
                <div
                  class="orm-col-xs-12 orm-col-md-10 orm-mb-16"
                  v-if="deliveryPickup.deliveryStreet"
                >
                  <div class="orm-mb-8">
                    {{ i18n("step2/deliverypickup/delivery") }}
                  </div>
                  <div class="orm-form__container">
                    <form-input
                      my-id="deliveryStreet"
                      :my-label="i18n('step2/deliverypickup/deliveryStreet')"
                      :is-readonly="true"
                      v-model="deliveryPickup.deliveryStreet"
                    ></form-input>
                    <div class="orm-row">
                      <div class="orm-col-xs-12 orm-col-md-4">
                        <form-input
                          my-id="deliveryZipcode"
                          :my-label="
                            i18n('step2/deliverypickup/deliveryZipcode')
                          "
                          :is-readonly="true"
                          v-model="deliveryPickup.deliveryZipcode"
                        ></form-input>
                      </div>
                      <div class="orm-col-xs-12 orm-col-md-8">
                        <form-input
                          my-id="deliveryCity"
                          :my-label="i18n('step2/deliverypickup/deliveryCity')"
                          :is-readonly="true"
                          v-model="deliveryPickup.deliveryCity"
                        ></form-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-md-10 orm-mb-16"
                  v-if="deliveryPickup.pickupStreet"
                >
                  <div class="orm-mb-8">
                    {{ i18n("step2/deliverypickup/pickup") }}
                  </div>
                  <div class="orm-form__container">
                    <form-input
                      my-id="pickupStreet"
                      :my-label="i18n('step2/deliverypickup/pickupStreet')"
                      v-model="deliveryPickup.pickupStreet"
                      :is-readonly="true"
                    ></form-input>
                    <div class="orm-row">
                      <div class="orm-col-xs-12 orm-col-md-4">
                        <form-input
                          my-id="pickupZipcode"
                          :my-label="i18n('step2/deliverypickup/pickupZipcode')"
                          :is-readonly="true"
                          v-model="deliveryPickup.pickupZipcode"
                        ></form-input>
                      </div>
                      <div class="orm-col-xs-12 orm-col-md-8">
                        <form-input
                          my-id="pickupCity"
                          :my-label="i18n('step2/deliverypickup/pickupCity')"
                          :is-readonly="true"
                          v-model="deliveryPickup.pickupCity"
                        ></form-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="orm-row">
          <div class="orm-col-xs-12 orm-mb-16">
            <div
              class="orm-background--white orm-reservation__data__container__inner"
              v-if="carID"
            >
              <div class="orm-row">
                <div class="orm-col-xs-12">
                  <h2 class="orm-headline__h1">{{ i18n("step4/formdata") }}</h2>
                  <div v-if="form.customer && requirements">
                    <div class="orm-row orm-my-16">
                      <div class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-4">
                        <h2 class="orm-headline__h3">
                          {{ i18n("form/personaldata") }}
                        </h2>
                        <div
                          class="orm-form__block orm-form__container orm-pr-md-70"
                        >
                          <form-input
                            my-id="formSalutation"
                            :my-label="i18n('form/label/salutation')"
                            :is-readonly="true"
                            :model-value="
                              store.getters['customer/GET_SALUTATION'](
                                form.customer.salutation_id
                              )
                            "
                          ></form-input>
                          <form-input
                            my-id="formName"
                            :my-label="i18n('form/label/name') || 'Name'"
                            :is-readonly="true"
                            v-model="form.customer.name1"
                            v-if="isLoggedin && getVisibility('name1')"
                          ></form-input>
                          <form-input
                            my-id="formFirstname"
                            :my-label="i18n('form/label/firstname')"
                            :is-readonly="true"
                            v-model="form.customer.firstname"
                            v-if="!isLoggedin && getVisibility('firstname')"
                          ></form-input>
                          <form-input
                            my-id="formLastname"
                            :my-label="i18n('form/label/lastname')"
                            :is-readonly="true"
                            v-model="form.customer.lastname"
                            v-if="!isLoggedin && getVisibility('lastname')"
                          ></form-input>
                          <form-input
                            v-if="getVisibility('email')"
                            my-id="formEmail"
                            :my-label="i18n('form/label/email')"
                            my-type="email"
                            :is-readonly="true"
                            v-model="form.customer.email"
                          ></form-input>
                          <form-input
                            v-if="getVisibility('phone_number')"
                            my-id="formPhone"
                            :my-label="i18n('form/label/phone')"
                            my-type="tel"
                            :is-readonly="true"
                            v-model="form.customer.phone_number"
                          ></form-input>
                          <form-input
                            v-if="getVisibility('company_name')"
                            my-id="formCompany"
                            :my-label="i18n('form/label/company')"
                            :is-readonly="true"
                            v-model="form.customer.company_name"
                          ></form-input>
                        </div>
                      </div>
                      <div class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-4">
                        <h2 class="orm-headline__h3">
                          {{ i18n("form/address") }}
                        </h2>
                        <div
                          class="orm-form__block orm-form__container orm-pr-md-70"
                        >
                          <form-input
                            v-if="getVisibility('street')"
                            my-id="formStreet"
                            :my-label="i18n('form/label/street')"
                            :is-readonly="true"
                            v-model="form.customer.street"
                          ></form-input>
                          <form-input
                            v-if="getVisibility('zipcode')"
                            my-id="formZipcode"
                            :my-label="i18n('form/label/zipcode')"
                            :is-readonly="true"
                            v-model="form.customer.zipcode"
                          ></form-input>
                          <form-input
                            v-if="getVisibility('city')"
                            my-id="formCity"
                            :my-label="i18n('form/label/city')"
                            :is-readonly="true"
                            v-model="form.customer.city"
                          ></form-input>
                          <form-input
                            my-id="formCountry"
                            :my-label="i18n('form/label/country') || 'Land'"
                            :is-readonly="true"
                            :model-value="
                              store.getters['customer/GET_COUNTRY_BY_ID'](
                                form.customer.country_id
                              ).country
                            "
                            v-if="
                              form.customer.country_id &&
                                getVisibility('country_id')
                            "
                          ></form-input>

                          <form-input
                            my-id="formOrigin"
                            :my-label="
                              i18n('form/label/origin') ||
                                'Wie sind Sie auf uns aufmerksam geworden'
                            "
                            :is-readonly="true"
                            :model-value="
                              store.getters['customer/GET_ORIGIN'](
                                form.customer.origin
                              ).translated_origin
                            "
                            v-if="form.customer.origin"
                          ></form-input>
                        </div>
                        <div v-if="!hasConcardis">
                          <h2 class="orm-headline__h3">
                            {{ i18n("form/payment") }}
                          </h2>
                          <div
                            class="orm-form__block orm-form__container orm-pr-md-70"
                          >
                            <form-input
                              my-id="formPayment"
                              :my-label="i18n('form/label/payment')"
                              :is-readonly="true"
                              :model-value="
                                store.getters['reservation/GET_PAYMENT_METHOD'](
                                  form.payment_method_id
                                )
                              "
                            ></form-input>
                          </div>
                        </div>
                      </div>
                      <div class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-4">
                        <h2 class="orm-headline__h3">
                          {{ i18n("form/message") }}
                        </h2>
                        <div
                          class="orm-form__block orm-form__container orm-pr-sm-70 orm-mb-0"
                        >
                          <form-textarea
                            my-id="formRemarks"
                            :my-label="i18n('form/label/remarks')"
                            my-rows="5"
                            :is-readonly="true"
                            v-model="form.remarks"
                          ></form-textarea>
                          <div
                            v-if="
                              store.getters['ORMgeneral/GET_MODULE'](
                                'ORM_LOGIN'
                              ) == 'J' && !isLoggedin
                            "
                          >
                            <h2 class="orm-headline__h3">
                              {{ i18n("form/account") }}
                            </h2>
                            <div class="orm-form__block">
                              <form-checkbox
                                my-fontbase="14"
                                my-name="formCreateLogin"
                                :my-label="i18n('form/label/account')"
                                :is-readonly="true"
                                v-model="form.customer.create_login"
                              ></form-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="orm-row bottom-md">
                      <div class="orm-col-xs-12 orm-col-md-6"></div>
                      <div class="orm-col-xs-12 orm-col-md-6 text-right">
                        <button
                          @click="edit('3')"
                          class="orm-button__cta outline small"
                        >
                          {{ i18n("general/edit") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="orm-row">
          <div class="orm-col-xs-12 orm-mb-16">
            <div
              class="orm-background--white orm-reservation__data__container__inner"
              v-if="carID"
            >
              <div class="orm-row">
                <div class="orm-col-xs-12 orm-col-md-7">
                  <h2 class="orm-headline__h1">
                    {{ i18n("step4/completeReservation") }}
                  </h2>
                  <h3
                    class="orm-headline__h3 orm-mt-32 orm-mb-8"
                    v-if="i18n('step4/legalnotice')"
                  >
                    {{ i18n("step4/legalnotice") }}
                  </h3>
                  <p
                    v-if="i18n('step4/legalnotice')"
                    class="orm-legalNotice"
                    v-html="i18n('step4/noticetext')"
                  ></p>
                  <div
                    v-if="
                      store.getters['ORMgeneral/GET_PARAMETER'](
                        'BORMLF_NO_CB_STEP4'
                      ) !== '1'
                    "
                  >
                    <h3 class="orm-headline__h3 orm-mt-32 orm-mb-8">
                      {{ i18n("step4/consent") }}
                    </h3>
                    <div class="orm-my-16" v-if="stationType">
                      <form-checkbox
                        my-fontbase="14"
                        v-model="validate.contractCheck"
                        my-name="contractCheck"
                        :my-label="
                          i18n('step4/' + stationType + '/agreementterms') ||
                            i18n('step4/agreementterms')
                        "
                        :is-required="true"
                        :error="errors.contractCheck"
                      >
                      </form-checkbox>
                    </div>
                    <div class="orm-my-16" v-if="stationType">
                      <form-checkbox
                        my-fontbase="14"
                        v-model="validate.dsgvoCheck"
                        my-name="dsgvoCheck"
                        :my-label="
                          i18n('step4/' + stationType + '/dsgvo') ||
                            i18n('step4/dsgvo')
                        "
                        :is-required="true"
                        :error="errors.dsgvoCheck"
                      >
                      </form-checkbox>
                    </div>
                    <div class="orm-my-16">
                      <form-checkbox
                        v-if="form.customer && !hideAllowmarketing"
                        my-fontbase="14"
                        v-model="form.customer.allow_marketing"
                        my-name="werbungCheck"
                        :my-label="i18n('step4/marketing')"
                      >
                      </form-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 orm-col-md-5 text-right bottom-self-xs"
                >
                  <div v-if="endpositions.length > 0 && !isCalculating">
                    <div
                      v-for="(position, index) in endpositions"
                      :key="index"
                      class="orm-price-item flex-container"
                    >
                      <span
                        v-if="position.rate == 'MWST' && position.rate != 'ES.'"
                        class="description"
                      >
                        {{ i18n("general/vat") || position.description }} ({{
                          convertCurrency(position.single_price)
                        }}):
                      </span>
                      <span
                        v-if="position.rate != 'MWST' && position.rate != 'ES.'"
                        class="description"
                      >
                        {{ i18n("general/netamount") || position.description }}:
                      </span>
                      <span
                        v-if="position.rate != 'ES.'"
                        class="orm-price_item_right"
                      >
                        {{ convertCurrency(position.total_price) }}
                      </span>
                      <span v-if="position.rate == 'ES.'" class="description">
                        <em>{{ i18n("general/total") }}:</em>
                      </span>
                      <span v-if="position.rate == 'ES.'" class="orm-pricetag">
                        <em>{{ convertCurrency(position.total_price) }}</em>
                      </span>
                    </div>
                    <!--<p class="orm-pricetag">
                      {{
                        store.getters["stations/GET_STATION_BY_ID"](
                          this.stationSelected
                        ).branch !== "Auto-Abo"
                          ? i18n("general/total")
                          : i18n("general/monthly") || "Monatlich"
                      }}:
                      <em>{{
                        convertCurrency(
                          showNettoPrice
                            ? endpositions[0].total_price
                            : endpositions[2].total_price
                        )
                      }}</em>
                    </p>
                    <p class="orm-smallprint" v-if="showSaleTax">
                      {{ endpositions[1].description }}
                    </p>
                    <p class="orm-smallprint orm-mb-0" v-else>&nbsp;</p>-->
                    <p class="orm-smallprint"></p>
                    <button
                      @click="validateForm"
                      class="orm-button__cta wide orm__cta"
                      :disabled="isLoading"
                    >
                      <i
                        v-if="isLoading"
                        class="fa fa-spinner-third orm-rotate360"
                      ></i>
                      <span v-if="!hasConcardis || payOffline">{{
                        i18n("step4/reservate")
                      }}</span>
                      <span v-else>{{ i18n("step4/submit") }}</span>
                    </button>
                  </div>
                  <div v-else>
                    <div class="orm-loader-spinner">
                      <i
                        class="fa fa-spinner-third orm-rotate360 orm-rotate360--big"
                      ></i>
                    </div>
                  </div>
                  <div v-if="hasConcardis && paymenttypeoffline">
                    <div v-if="payOffline">
                      <span
                        class="orm-payswitch"
                        @click="
                          payOffline = !payOffline;
                          generateTarif('online');
                        "
                      >
                        <i class="fa fa-chevron-right"></i>
                        {{ i18n("step4/pay_online") }}
                        ( -
                        {{
                          convertCurrency(
                            showNettoPrice
                              ? extrasOfflinePayment
                              : paymenttypeoffline[env.VUE_APP_PAYMENT_OFFLINE]
                                  .price
                          )
                        }}
                        )
                      </span>
                    </div>
                    <div v-else>
                      <span
                        class="orm-payswitch"
                        @click="
                          payOffline = !payOffline;
                          generateTarif('offline');
                        "
                      >
                        <i class="fa fa-chevron-right"></i>
                        {{ i18n("step4/pay_offline") }}
                        (
                        <span v-if="paymenttypeoffline"
                          >+
                          {{
                            convertCurrency(
                              showNettoPrice
                                ? extrasOfflinePayment
                                : paymenttypeoffline[
                                    env.VUE_APP_PAYMENT_OFFLINE
                                  ].price
                            )
                          }}</span
                        >
                        )
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { defineComponent } from "vue";

import reservationheader from "@/components/reservation/header.vue"; // @ is an alias to /src
import reservationinfobar from "@/components/reservation/infobar_reservation.vue"; // @ is an alias to /src
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import { convertCurrency } from "@/constants/formater";

import FormInput from "@/components/ui/INPUTS/FormInput.vue"; // @ is an alias to /src
import FormTextarea from "@/components/ui/INPUTS/FormTextarea.vue";
import FormCheckbox from "@/components/ui/INPUTS/FormCheckbox.vue";

import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import store from "@/store";
import ErrorModal from "@/components/modals/modal-error.vue";
import ConcardisModal from "@/components/modals/modal-concardis.vue";
import {
  formateDateShort,
  formatTime,
  formateDateDayLong,
} from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps, getPayRoutes } from "@/constants/getRoutes";
import {
  AdyenCheckout,
  Card,
  CashAppPay,
  Dropin,
  GooglePay,
  PayPal,
} from "@adyen/adyen-web";
import payment from "@/store/modules/orm/payment";

export default defineComponent({
  name: "ReservationStep4",
  components: {
    Footer,
    reservationheader,
    reservationinfobar,
    equipIcon,
    Slider,
    FormInput,
    FormTextarea,
    FormCheckbox,
    ErrorModal,
    ConcardisModal,
  },
  mixins: [i18n, stripHTML],
  setup() {
    return {
      store,
      formateDateShort,
      formatTime,
      formateDateDayLong,
      routeToSteps,
    };
  },
  data() {
    return {
      env: process.env,
      date: Object,
      time: Object,
      form: Object,
      images: null,
      carID: null,
      stationSelected: store.getters["userSession/GET_STATION"],
      selectedCargroup: Object,
      selectedCargroupInfo: Object,
      selectedVehicleInfo: null,
      session: Object,
      startstation: Object,
      endstation: Object,
      subrates: [],
      insurances: [],
      deliveryrates: [],
      endpositions: [],
      extras: [],
      voucherrates: Array,
      tarif: Object,
      tarifOffline: null,
      hasbilling: false,
      hasDeliveryPickup: false,
      deliveryPickup: Object,
      price: [],
      convertCurrency,
      isLoading: false,
      isCalculating: false,
      widgetRef: "null",
      showConcardis: false,
      hasConcardis: false,
      paymentData: {
        data: null,
        error: null,
        loading: false,
        processing: false,
      },
      paymentLoading: false,
      paymenttypeoffline: null,
      paymenttypeonline: null,
      payOffline: false,
      validate: {
        contractCheck: false,
        dsgvoCheck: false,
      },
      errors: {
        contractCheck: false,
        dsgvoCheck: false,
      },
      error: {
        show: false,
        loadTimes: true,
        resetSession: true,
        hidebuttons: false,
        data: {
          header: this.i18n("error/default/header"),
          content: this.i18n("error/default/content"),
          buttonFirst: "Home",
          buttonFirstLabel: this.i18n("error/default/buttonFirstLabel"),
        },
      },
      isLoggedin: false,
      contribution: this.i18n("step2/contribution") || "SB: ",
      showSaleTax: true,
      showNettoPrice: false,
      extrasOfflinePayment: 0,
      hideAllowmarketing: false,
      stationType: null,
      requirements: null,
      hasRedirected: false,
    };
  },
  async beforeMount() {
    const showTax = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_HIDE_TAX_TEXT"
    );
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );
    const hideAllowmarketing = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_FREIWILLIGE_EINWILLIGUNG_KUNDENBETREUUNG"
    );
    if (hideAllowmarketing == 0) {
      this.hideAllowmarketing = true;
    }

    switch (showTax) {
      case "1":
        this.showSaleTax = false;
        break;
      default:
        break;
    }
    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }

    this.paymenttypeoffline = await store.getters[
      "reservation/GET_PAYMENTTYPE_OFFLINE"
    ];
    if (this.paymenttypeoffline) {
      this.extrasOfflinePayment = await store.getters[
        "reservation/GET_EXTRA_CATEGORIES"
      ].find((x) => x.id === "PAY_").extras[1].single_price;
    }

    if (
      store.getters["ORMgeneral/GET_MODULE"]("ZAHLUNGSDIENSTLEISTER") == "J"
    ) {
      if (
        Object.keys(store.getters["reservation/GET_PAYMENTTYPE"])[0] ===
        process.env.VUE_APP_PAYMENT_OFFLINE
      ) {
        this.payOffline = true;
      }

      /* ABFRAGE DER ONLINE PAYMENT PROVIDER */

      /* ABFRAGE NACH CONCARDIS - START */
      const merchantId = await store.dispatch(
        "payment/GET_CONCARDIS_MERCHANDID"
      );

      if (merchantId !== "error") {
        if (merchantId["payment_provider"] === "CONCARDIS") {
          this.hasConcardis = true;

          const payengine = document.createElement("script");
          const concardisurl =
            store.getters["ORMgeneral/GET_PARAMETER"](
              "SCONCARDIS_VIRTUAL_TERMINAL_URL"
            ) || "https://pptest.payengine.de/";

          payengine.setAttribute(
            "src",
            concardisurl + "bridge/1.0/payengine.min.js"
          );
          payengine.async = true;
          document.head.appendChild(payengine);

          const payenginewidget = document.createElement("script");
          payenginewidget.setAttribute(
            "src",
            concardisurl + "widgetjs/payengine.widget.min.js"
          );
          payenginewidget.async = true;
          document.head.appendChild(payenginewidget);
        }
      }
      /* ABFRAGE NACH CONCARDIS - END */
    }
  },
  async created() {
    this.stationType = await store.getters["userSession/GET_STATIONTYPE"];

    if (process.env.VUE_APP_DELIVERYPICKUP == "true") {
      this.hasDeliveryPickup = true;
    }
    this.selectedCargroup = await store.getters["reservation/GET_RESERVATION"];

    if (this.selectedCargroup == null) {
      this.error.show = true;
      return false;
    }

    const carID = await store.getters["reservation/GET_RESERVATION_CARGROUP"]();
    this.carID = carID;

    if (carID == null) {
      return false;
    }
    const branch = await store.getters["stations/GET_STATION_BY_ID"](
      this.stationSelected
    ).branch;
    if (
      (branch == "Auto-Abo" && this.$route.name != "Abo_Step4") ||
      (branch != "Auto-Abo" && this.$route.name != "Reservation_Step4")
    ) {
      this.error.show = true;
      return false;
    }
    this.paymenttypeoffline = await store.getters[
      "reservation/GET_PAYMENTTYPE_OFFLINE"
    ];
    this.paymenttypeonline = await store.getters[
      "reservation/GET_PAYMENTTYPE_ONLINE"
    ];
    const deliveryPickup = await store.getters[
      "reservation/GET_DELIVERY_PICKUP"
    ];
    this.deliveryPickup = JSON.parse(JSON.stringify(deliveryPickup));

    this.form = await store.getters["reservation/GET_CUSTOMER"];

    const station = await store.getters["reservation/GET_RESERVATION_STATION"];

    this.startstation = store.getters["stations/GET_STATION_BY_ID"](
      station.start
    );

    if (!station.end) {
      this.endstation = store.getters["stations/GET_STATION_BY_ID"](
        station.start
      );
    } else {
      this.endstation = store.getters["stations/GET_STATION_BY_ID"](
        station.end
      );
    }

    this.setTarif(this.selectedCargroup);

    this.date = store.getters["reservation/GET_RESERVATION_DATE"];
    this.time = store.getters["reservation/GET_RESERVATION_TIME"];

    this.selectedCargroupInfo = await store.getters[
      "cargroup/GET_CARGROUP_BY_ID"
    ](carID);
    this.images = await store.getters["cargroup/GET_GLOBAL_CARGROUPS_IMAGE"](
      carID
    );
    if (
      store.getters["stations/GET_STATION_BY_ID"](this.stationSelected)
        .branch === "Auto-Abo"
    ) {
      this.selectedVehicleInfo = await store.getters["userSession/GET_VEHICLE"];
      const images = [];
      this.selectedVehicleInfo.images.exterior.forEach((element) => {
        images.push({ image: element.url });
        // console.log(element);
      });
      this.selectedVehicleInfo.images.interior.forEach((element) => {
        images.push({ image: element.url });
        // console.log(element);
      });
      this.images = images;
    }

    this.voucherrates = this.selectedCargroup.voucher_rates;

    const logincheck = await store.getters["userSession/IS_LOGGEDIN"];
    if (logincheck) this.isLoggedin = true;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // console.log(urlParams);
    if (urlParams.has("CANCEL") || urlParams.has("FAILURE")) {
      window.history.pushState({}, document.title, window.location.pathname);
      store.dispatch("payment/DELETE_CONCARDIS");
      store.dispatch("payment/DELETE_COMPUTOP");
      if (!urlParams.has("PayID") && !urlParams.has("Status")) {
        this.submit();
      }
    }
    // url param data muss bei computop mit an reservate übergeben werden
    // bookingpaymenttype muss erweitert werden um neues feld mit den daten
    if (urlParams.has("SUCCESS")) {
      this.error.show = true;
      this.error.data = {
        header: "Reservating ...",
        content: "Please Wait",
        buttonFirst: "Home",
        buttonFirstLabel: this.i18n("error/default/buttonFirstLabel"),
      };
      this.error.hidebuttons = true;

      if (urlParams.has("PayID") && urlParams.has("Status")) {
        await this.processComputopPayment(urlParams);
      }

      this.reservate();
      window.history.pushState({}, document.title, window.location.pathname);
    }
    this.requirements = await store.getters[
      "ORMgeneral/GET_INPUTFIELD_REQUIREMENTS"
    ]("step3_personal_information");

    if (this.requirements) {
      this.requirements.forEach((element) => {
        if (element.required) this.validate[element.name] = false;
      });
    }
  },
  methods: {
    setTarif(tarif) {
      this.insurances = tarif.insurance_rates;
      this.deliveryrates = tarif.delivery_pickup_rates;
      this.endpositions = tarif.end_positions;
      this.subrates = tarif.sub_rates;
      tarif.main_rates.forEach((element) => {
        if (element.main_rate) {
          this.price.push(element);
        }
      });
    },
    edit(route) {
      buildDataLayer("orm_step4_edit_step" + route, {}, null);
      // this.$router.push({ name: "Reservation_Step" + route });
      routeToSteps(this, route);
    },
    getVisibility(input) {
      const visible = this.requirements.find((x) => x.name === input);
      return visible ? visible.visible : null;
    },
    validateForm() {
      buildDataLayer("orm_buy_btn_clicked", {}, null);

      const noCheckboxes =
        this.$store.getters["ORMgeneral/GET_PARAMETER"](
          "BORMLF_NO_CB_STEP4"
        ) === "1";

      if (!noCheckboxes) {
        if (!this.validate.contractCheck) {
          this.errors.contractCheck = true;
        } else {
          this.errors.contractCheck = false;
        }
        if (!this.validate.dsgvoCheck) {
          this.errors.dsgvoCheck = true;
        } else {
          this.errors.dsgvoCheck = false;
        }
      }

      if (
        noCheckboxes ||
        (this.validate.contractCheck && this.validate.dsgvoCheck)
      ) {
        this.isLoading = true;

        if (!this.hasConcardis || this.payOffline) {
          buildDataLayer("add_payment_info", {}, null);
          this.reservate();
        } else {
          buildDataLayer("add_payment_info", {}, null);
          this.submit();
        }
      }
    },
    async cancel() {
      this.showConcardis = false;
      this.isLoading = false;
    },
    async calcPrice() {
      this.loadingPrice = true;
      this.isCalculating = true;
      let vehicle_id = null;
      if (
        store.getters["stations/GET_STATION_BY_ID"](this.stationSelected)
          .branch === "Auto-Abo"
      ) {
        vehicle_id = await store.getters["userSession/GET_VEHICLE"].id;
      }

      //vehicle_id: this.selectedCargroupInfo.id,
      // console.log(vehicle_id);
      // console.log(this.carID);
      this.selectedCargroup = await store
        .dispatch("reservation/CALCULATE_PRICE", {
          id: this.carID,
          extras: true,
          vehicle_id,
        })
        .then((res) => {
          if (!res.errors) {
            store.dispatch("reservation/SET_RESERVATION_TARIFS", res);
            this.subrates = res.sub_rates;
            this.mainrates = JSON.parse(JSON.stringify(res.main_rates));
            this.deliveryrates = JSON.parse(
              JSON.stringify(res.delivery_pickup_rates)
            );
            this.endpositions = res.end_positions;
            this.mainrates.sort((a, b) => (a.position > b.position ? 1 : -1));
            this.isLoading = false;
            this.isCalculating = false;
            this.voucherrates = JSON.parse(JSON.stringify(res.voucher_rates));

            return res;
          } else {
            console.log("errors", res);
          }
        });
    },
    async generateTarif(type) {
      this.isLoading = true;
      let paytype = this.paymenttypeoffline;
      if (type == "online") {
        paytype = this.paymenttypeonline;
      }
      const rate = Object.keys(paytype)[0];
      const id = paytype[rate].id;
      const amount = paytype[rate].amount;

      store
        .dispatch("reservation/SET_PAYMENTTYPE", { rate, id, amount })
        .then((res) => {
          this.calcPrice();
          return res;
        });
    },
    pay() {
      this.paymentData.loading = true;
      // console.log( this.paymentData);
      const onPayCallback = (error, result) => {
        console.log("On pay callback", error, result);
      };
      /* eslint-disable */
      const onVallCallback = (error, result) => {
        if (!error) {
          this.paymentData.processing = true;
          window.PayEngineWidget.pay(this.widgetRef, onPayCallback);
        } else {
          this.paymentData.loading = false;
        }
      };
      /* eslint-enable */
      window.PayEngineWidget.validate(this.widgetRef, onVallCallback);
    },

    async submit() {
      this.paymentData.error = null;
      this.paymentData.loading = true;
      this.paymentData.processing = false;
      const merchantId = await store.dispatch(
        "payment/GET_CONCARDIS_MERCHANDID"
      );
      if (merchantId == "error") {
        this.error.show = true;
        this.error.data.content = this.i18n("error/offer/content");
        return false;
      }
      const initCallback = (error, iframeName) => {
        this.widgetRef = iframeName;
        this.paymentData.loading = false;
      };
      const resultCallback = (error, paymentInstrument) => {
        // console.log("Error/Result:", error, paymentInstrument);
        if (error) {
          console.log("CONCARDIS ERROR", error);
          store.dispatch("payment/DELETE_CONCARDIS");
          this.paymentData.error = error;
          this.paymentData.loading = false;
        } else {
          console.log(paymentInstrument);
          if (paymentInstrument.code == 201) {
            // console.log(paymentInstrument.message);
            this.reservate();
          }
          // else if (paymentInstrument.redirectUrl) {
          //   location.href = paymentInstrument.redirectUrl;
          // } else {
          //   console.log("CONCARDIS ERROR");
          //   this.showConcardis = false;
          // }
        }
      };
      function paypalErrorCallback(error) {
        console.log("On paypal error: ", error);
      }

      function paypalCancelCallback() {
        console.log("On paypal cancel");
      }

      function paypalConfirmCallback(orderId) {
        console.log("On paypal confirm: ", orderId);
      }

      function paypalSuccessCallback(orderId) {
        console.log("On paypal success: ", orderId);
        this.reservate();
      }

      const optionalParameters = {
        language: "de",
        layout: "dropdown",
        customStyleId: null,
        hidePayButton: true,
        hideTitleIcons: true,
        skipFinalResultView: true,
        redirectUser: true,
        paypal: {
          paypalRecurringBillingAgreement: false,
          styles: {
            label: "paypal",
            size: "responsive",
            color: "gold",
            shape: "pill",
          },
        },
        optionalFields: {},
      };

      optionalParameters.initCallback = initCallback;

      optionalParameters.paypal.errorCallback = paypalErrorCallback;
      optionalParameters.paypal.cancelCallback = paypalCancelCallback;
      optionalParameters.paypal.confirmCallback = paypalConfirmCallback;
      optionalParameters.paypal.successCallback = paypalSuccessCallback;

      const order = await store.dispatch("payment/SET_ORDER");
      const setCallbackURLS = async () => {
        optionalParameters.async = await getPayRoutes();
        optionalParameters.paymentDetails = {
          paypal: await getPayRoutes(),
        };
        // console.log(optionalParameters);
      };

      if (merchantId["payment_provider"] === "COMPUTOP") {
        store.dispatch("payment/MAKE_ORDER").then((result) => {
          this.paymentData.data = {
            ...result,
            payment_provider: merchantId["payment_provider"],
          };
          console.log("Computop API Response:", result);

          const computopUrl = new URL(result.url);
          console.log("Weiterleitung zu Computop:", computopUrl.toString());
          window.location.href = computopUrl.toString();
        });
      } else if (!order || merchantId["payment_provider"] === "ADYEN") {
        console.log("order existiert nicht");
        store.dispatch("payment/MAKE_ORDER").then((result) => {
          this.paymentData.data = {
            ...result,
            payment_provider: merchantId["payment_provider"],
          };
          console.log(this.paymentData.data);
          setCallbackURLS();
          console.log("merchantId", merchantId);

          setTimeout(() => {
            if (merchantId["payment_provider"] === "CONCARDIS") {
              this.showConcardis = true;
              window.PayEngine.setPublishableKey(merchantId["merchant_id"]);
              setTimeout(() => {
                window.PayEngineWidget.initAsInlineComponent(
                  "inline-widget-container",
                  merchantId["merchant_id"],
                  result.orderId,
                  optionalParameters,
                  resultCallback
                );
              }, 250);
            } else if (merchantId["payment_provider"] === "ADYEN") {
              this.showConcardis = true;
              console.log(merchantId);
              const configuration = {
                clientKey: merchantId["client_key"],
                locale: "de_DE",
                environment: "test", // Change to 'live' for production
                showPayButton: true,
                session: result,
                onPaymentCompleted: (result, component) => {
                  console.log("result: " + JSON.stringify(result));
                  this.paymentData.loading = true;
                  this.reservate();
                },
                onError: (error, component) => {
                  console.error(
                    error.name,
                    error.message,
                    error.stack,
                    component
                  );
                },
              };
              this.initializeAdyen(configuration);
            } /*else if (merchantId['payment_provider'] === 'COMPUTOP' && !this.hasRedirected) {
              console.log(merchantId);
              console.log("Computop API Response:", result);

              const successUrl = `${window.location.origin}/payment-success`;
              const failureUrl = `${window.location.origin}/payment-failure`;

              const computopUrl = new URL(result.url);
              computopUrl.searchParams.append("successUrl", 'https://mein-testserver.de/payment-success');
              computopUrl.searchParams.append("failureUrl", 'https://mein-testserver.de/payment-failure');

              console.log("Weiterleitung zu Computop:", computopUrl.toString());

              this.hasRedirected = true; // Schleife verhindern
              //window.location.href = computopUrl.toString();
            }*/
          }, 500);
        });
      } else {
        console.log("order existiert");
        this.showConcardis = true;
        this.paymentData.data = {
          ...order,
          payment_provider: merchantId["payment_provider"],
        };
        setCallbackURLS();

        setTimeout(() => {
          if (merchantId["payment_provider"] === "CONCARDIS") {
            window.PayEngine.setPublishableKey(merchantId["merchant_id"]);
            window.PayEngineWidget.initAsInlineComponent(
              "inline-widget-container",
              merchantId["merchant_id"],
              order.orderId,
              optionalParameters,
              resultCallback
            );
          } else if (merchantId["payment_provider"] === "ADYEN") {
            console.log("");
          }
        }, 500);
      }
    },
    async initializeAdyen(configuration) {
      const checkout = await AdyenCheckout(configuration);

      const dropinConfiguration = {
        paymentMethodComponents: [Card, PayPal, CashAppPay, GooglePay],
      };
      const dropin = new Dropin(checkout, dropinConfiguration).mount(
        "#inline-widget-container"
      );

      this.paymentData.loading = false;
    },
    async reservate() {
      await store.dispatch(
        "reservation/SET_MARKETING",
        this.form.customer.allow_marketing
      );

      await store.dispatch("reservation/RESERVATE").then((result) => {
        if (
          result.status == 400 ||
          result.status == 500 ||
          result.status == 404
        ) {
          if (result.data.errorCode == "CREDENTIALS-EXIST") {
            this.error = {
              show: true,
              loadTimes: false,
              resetSession: false,
              data: {
                header: this.i18n("error/email/header"),
                content: "", //result.data.message,
                buttonFirst: "Reservation_Step3",
                buttonFirstLabel: this.i18n("error/email/buttonFirstLabel"),
                // buttonSecond: "CREDENTIALS-EXIST",
                // buttonSecondLabel: "ohne Kundenkonto anlegen reservieren",
              },
            };
          } else {
            this.error.show = true;
            this.error.data.content = this.i18n("error/offer/content");

            /// REFUND CONCARSID BOOKING IF RESERVATION ERROR
            if (this.hasConcardis) {
              store.dispatch("payment/REFUND_ORDER");
            }

            store.commit("reservation/MUTATE_DELETE_RESERVATION");
            this.error.data.content = result;
          }
        } else {
          buildDataLayer("purchase", {}, null);
          // this.$router.push({
          //   name: "Reservation_Final",
          //   params: { data: result.data },
          // });
          routeToSteps(this, "success", { data: result.data });
        }
      });
    },
    async processComputopPayment(urlParams) {
      const paymentData = {
        payment_provider: "COMPUTOP",
        computop_response: urlParams.toString(),
      };
      urlParams.forEach((value, key) => {
        paymentData[key] = value;
      });
      store.dispatch("payment/SET_COMPUTOP_PAYMENT", paymentData);
    },
  },
});
</script>
